import { useEffect } from "react";
import { SITE_URL } from "@/data/site";

const upsertMeta = (attr, key, content) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const Seo = ({ title, description, jsonLd, robots = "index, follow, max-image-preview:large" }) => {
    useEffect(() => {
        document.title = title;
        upsertMeta("name", "description", description);
        upsertMeta("name", "robots", robots);
        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:locale", "fr_FR");
        upsertMeta("property", "og:url", `${SITE_URL}${window.location.pathname}`);
        upsertMeta("property", "og:image", `${SITE_URL}/assets/og-image.jpg`);
        upsertMeta("name", "twitter:card", "summary_large_image");

        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `${SITE_URL}${window.location.pathname}`);

        let script;
        if (jsonLd) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.id = "seo-jsonld";
            script.text = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
        return () => {
            if (script) script.remove();
        };
    }, [title, description, jsonLd]);
    return null;
};

export default Seo;
